import { I18N } from "oc-I18N";
import { isEmpty } from "oc-commons/Commons";
import * as Dialogs from "oc-ui/dialogs/Dialogs";
import { useEffect, useState } from "react";
import { UserSvg } from "../inlinesvgs/UserSvg";
import cn from "classnames";

export interface UserMenuProps {
  additionalClasses?: string;
  align?: string;
}

export function UserMenu({ additionalClasses, align }: UserMenuProps) {
  const [updateCount, setupdateCount] = useState(0);
  const [formVisible, setFormVisible] = useState(false);
  useEffect(handlePossibleFailedLogin, []);

  function renderLoginForm() {
    return (
      <form
        name="loginform"
        className="form"
        action={APP.settings.loginUrl}
        method="post"
        onSubmit={() => addLoginParam()}
      >
        <div className="info center" role="status">
          {I18N("Melden Sie sich an, um gespeicherte Planungen aufzurufen")}
        </div>

        <input
          type="text"
          name="login"
          className="input"
          placeholder={I18N("Username")}
          aria-label={I18N("aria::Username")}
          data-input-key="username"
          required
        />
        <input
          type="password"
          name="password"
          className="input"
          placeholder={I18N("Password")}
          aria-label={I18N("aria::Password")}
          data-input-key="password"
          required
        />
        <button
          type="submit"
          className="button button--primary hover-shadow"
          data-testid="UserMenu-Login-Button"
          data-button-key="login"
        >
          {I18N("Login")}
        </button>

        <a className="center" href={APP.settings.forgotPasswordUrl}>
          {I18N("forgot password")}
        </a>
        <a className="center" href={APP.settings.registrationUrl}>
          {I18N("Registrieren")}
        </a>
      </form>
    );
  }

  function renderLogoutForm() {
    return (
      <div className="form">
        <a
          href={APP.settings.userpageUrl}
          className="button button--secondary "
          aria-label={I18N("aria::Meine Konfigurationen")}
          data-button-key="meine-konfigurationen"
        >
          {I18N("Meine Konfigurationen")}
        </a>
        <button
          type="button"
          onClick={() => {
            if (window.confirm(I18N("Wirklich abmelden?"))) {
              logoutWithoutReload();
            }
          }}
          className="button button--secondary "
          aria-label={I18N("aria::Abmelden")}
          data-button-key="abmelden"
        >
          {I18N("Abmelden")}
        </button>
      </div>
    );
  }

  async function logoutWithoutReload() {
    const response = await fetch(APP.settings.logoutUrl, {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
      },
      redirect: "follow",
    });
    if (response.status == 200) {
      console.log("LOGGED OUT SUCCESS");
      APP.settings.userLoggedIn = false;
      delete APP.settings.userName;
      setupdateCount((s) => s + 1);
    }
  }

  function handlePossibleFailedLogin() {
    if (window.location.search.indexOf("login=1") > -1) {
      Dialogs.showOk(I18N("Login fehlgeschlagen"));
      removeLoginParam();
    }
  }

  function addLoginParam() {
    if (history.pushState) {
      const newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?login=1";
      window.history.pushState({ path: newurl }, "", newurl);
    }
  }

  function removeLoginParam() {
    if (history.pushState) {
      const newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        window.location.search.replace("?login=1", "").replace("login=1", "");
      window.history.pushState({ path: newurl }, "", newurl);
    }
  }

  return (
    <div key={updateCount} className={cn("userMenu", additionalClasses)}>
      <button
        type="button"
        data-testid="UserMenu-Button"
        data-button-key="user-menu"
        aria-label={I18N("aria::Nutzer Login")}
        aria-expanded={formVisible}
        aria-haspopup="dialog"
        className="login-popup-trigger icon-svg"
        onClick={() => setFormVisible((s) => !s)}
      >
        <UserSvg />
      </button>

      {formVisible && (
        <div
          className="backdrop"
          onClick={() => setFormVisible(false)}
          onKeyDown={(e) => e.key === "Escape" && setFormVisible(false)}
          role="button"
          tabIndex={0}
          aria-label={I18N("aria::Menü schließen")}
        ></div>
      )}

      {formVisible && (
        <div
          className={cn("loginPopup", align)}
          role="dialog"
          aria-modal="true"
          data-group-key={APP.settings.userLoggedIn ? "user-popup-eingeloggt" : "user-popup-login"}
          aria-label={
            APP.settings.userLoggedIn ? I18N("aria::Benutzermenu") : I18N("aria::Login-Formular")
          }
        >
          {!isEmpty(APP.settings.userName) && (
            <span className="username" aria-label={I18N("aria::Angemeldet als")}>
              {APP.settings.userName}
            </span>
          )}
          {APP.settings.userLoggedIn ? renderLogoutForm() : renderLoginForm()}
        </div>
      )}
    </div>
  );
}
